var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "bundle-wizard uk-modal-container",
    attrs: {
      "auto-overflow": "",
      "title": "Bundle-Assistent"
    },
    on: {
      "hidden": _vm.onHidden
    }
  }, [(_vm.allBundlesExist) ? _c('alert-box', {
    attrs: {
      "icon": "info"
    }
  }, [_vm._v(_vm._s(_vm.$t('hints.allBundlesExist')))]) : _vm._e(), _vm._v(" "), (_vm.hasErrors) ? _c('alert-box', {
    attrs: {
      "icon": "bolt",
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('hints.errorsOccurred')))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-justify uk-table-divider"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.bundleDefinitions), function(bundling) {
    return _c('th', {
      key: bundling.position,
      staticClass: "bundle-wizard__cell",
      style: ({
        width: _vm.columnWidth
      }),
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(bundling.productFamily.name))])
  }), _vm._v(" "), _c('th', {
    staticClass: "bundle-wizard__cell bundle-wizard__cell--input"
  }, [_vm._v(_vm._s(_vm.$t('fields.bundleArticleNumber')))])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.bundleCombinations), function(combination) {
    return _c('tr', {
      key: combination.articleNumber
    }, [_vm._l((combination.products), function(product) {
      return [_c('td', {
        key: product.articleNumber,
        staticClass: "bundle-wizard__cell bundle-wizard__cell--thumbnail",
        class: {
          'bundle-wizard__cell--disabled': !combination.articleNumber
        }
      }, [(product.teaserImage) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'product',
            params: {
              id: product.id
            }
          },
          "tabindex": "-1",
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "alt": product.name,
          "src": product.teaserImage.thumbImageUrl
        }
      })]) : _c('text-placeholder')], 1), _vm._v(" "), _c('td', {
        key: product.articleNumber,
        staticClass: "bundle-wizard__cell",
        class: {
          'bundle-wizard__cell--disabled': !combination.articleNumber
        },
        style: ({
          width: _vm.columnWidth
        })
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'product',
            params: {
              id: product.id
            }
          },
          "tabindex": "-1",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(product.variantName || product.name))]), _vm._v(" "), _c('div', {
        staticClass: "uk-text-muted"
      }, [_vm._v(_vm._s(product.articleNumber))])], 1)]
    }), _vm._v(" "), _c('td', {
      staticClass: "bundle-wizard__cell bundle-wizard__cell--input"
    }, [(combination.exists) ? _c('span', {
      staticClass: "uk-text-success"
    }, [_vm._v(_vm._s(_vm.$t('hints.bundleExists', {
      articleNumber: combination.articleNumber
    })))]) : _c('form-group', {
      attrs: {
        "errors": combination.errors,
        "label": false
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (combination.articleNumber),
        expression: "combination.articleNumber"
      }],
      staticClass: "uk-input",
      class: {
        'uk-form-danger': combination.errors.length > 0
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (combination.articleNumber)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          combination.articleNumber = $event.target.value
        }, function($event) {
          combination.errors = []
        }],
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.insertBundleProducts($event)
        }
      }
    })])], 1)], 2)
  }))]), _vm._v(" "), _c('common-button', {
    attrs: {
      "disabled": _vm.submitDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.insertBundleProducts
    },
    slot: "buttons"
  }, [_vm._v(_vm._s(_vm.$t('actions.createBundles', {
    count: _vm.createdBundleCount
  })))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f468ef0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/BundleWizard.vue
// module id = 1920
// module chunks = 0